import { render } from "./Route.vue?vue&type=template&id=f019d2cc&scoped=true&lang=pug"
import script from "./Route.vue?vue&type=script&lang=ts"
export * from "./Route.vue?vue&type=script&lang=ts"

import "./Route.vue?vue&type=style&index=0&id=f019d2cc&lang=scss&scoped=true"
import "./Route.vue?vue&type=style&index=1&id=f019d2cc&lang=scss"
script.render = render
script.__scopeId = "data-v-f019d2cc"

export default script